import Sidenav from "../templates/sidenav-template";
import { ToastContainer } from "react-toastify";
import VehicleLogList from "../data-tables/vehicle-logs-table";
import { LOG_RECORDS_MANAGER } from "../components/log-records-manager";
import React, { useEffect, useState, useRef } from 'react';

function LogPage() {
    const { VEHICLE_DELETE_LOG, VEHICLE_LOGS_FETCH } = LOG_RECORDS_MANAGER();

    useEffect(() => {
        VEHICLE_LOGS_FETCH();
        VEHICLE_DELETE_LOG();
    }, []);

    return (
        <div className="d-flex column log-page">
            <ToastContainer />
            <Sidenav />
            <VehicleLogList />
        </div>
    )
}

export default LogPage;